import React from 'react';
import { graphql } from 'gatsby';
import Layout from '../components/layout';
import Seo from '../components/seo';
import parseFlexibleContent from '../utils/parse-flexible-content';
import renderFlexibleContent from '../utils/render-flexible-content';
import { SINGLE, MULTIPLE } from '../utils/constants';
import PageHero from '../components/molecules/page-hero';
import Intro from '../components/molecules/intro';
import TextImageAside from '../components/molecules/text-image-aside';
import AdditionalContent from '../components/molecules/additional-content';
import TestimonialSection from '../components/molecules/testimonial-section';
import FAQs from '../components/molecules/faqs';
import FormRenderer from '../components/organisms/form-renderer';

const modules = {
  Hero: PageHero,
  TextImageAside,
  Intro,
  Testimonial: TestimonialSection,
  Form: FormRenderer,
  Faqs: FAQs,
  AdditionalContent,
  OnSaleForm: FormRenderer,
  OffSaleForm: FormRenderer,
};

function parseEmbedKey(key) {
  switch (key) {
    case 'offSaleForm':
      return 'form';
    case 'onSaleForm':
      return 'form';
    default:
      return key;
  }
}

const Webinar = ({ data }) => {
  const flexibleContent = parseFlexibleContent(data.page.acf.flexible_content_webinar);

  const injectData = {
    OnSaleForm: {
      form: {
        id: 'registration',
      },
    },
    OffSaleForm: {
      form: {
        id: 'registration',
      },
    },
  };

  const embeds = [
    {
      key: 'testimonial',
      type: MULTIPLE,
    },
    {
      key: 'offSaleForm',
      type: SINGLE,
    },
    {
      key: 'onSaleForm',
      type: SINGLE,
    },
  ];

  const renderConditions = {
    OnSaleForm: () => {
      return data.page.acf.on_sale;
    },
    OffSaleForm: () => {
      return !data.page.acf.on_sale;
    },
  };

  const ogImage = data.page.yoast.ogImage && data.page.yoast.ogImage.localFile;
  const twitterImage = data.page.yoast.twitterImage && data.page.yoast.twitterImage.localFile;

  return (
    <Layout>
      <Seo
        fallbackTitle={data.page.title}
        title={data.page.yoast.title}
        description={data.page.yoast.metadesc}
        ogImage={ogImage}
        twitterImage={twitterImage}
      />
      {renderFlexibleContent(flexibleContent, modules, injectData, embeds, parseEmbedKey, renderConditions)}
    </Layout>
  );
};

export const query = graphql`
  query($id: Int!) {
    page: wordpressWpWebinar(wordpress_id: { eq: $id }) {
      yoast {
        title
        metadesc
      }
      title
      acf {
        on_sale
        flexible_content_webinar {
          module: __typename
          ... on WordPressAcf_hero {
            title
            body
            background_image {
              localFile {
                childImageSharp {
                  sizes(maxWidth: 1280) {
                    ...GatsbyImageSharpSizes
                  }
                }
              }
            }
          }
          ... on WordPressAcf_intro {
            title
            body
          }
          ... on WordPressAcf_additional_content {
            title
            body
            no_background
          }
          ... on WordPressAcf_testimonial {
            testimonial {
              wordpress_id
              acf {
                attribution
                body
              }
            }
          }
          ... on WordPressAcf_on_sale_form {
            on_sale_form {
              wordpress_id
              acf {
                title
                cta_button_text
                background_image {
                  localFile {
                    childImageSharp {
                      sizes(maxWidth: 640) {
                        ...GatsbyImageSharpSizes
                      }
                    }
                  }
                }
                purchase_url
              }
            }
          }
        }
      }
    }
  }
`;

export default Webinar;
